import React, { useState, useEffect } from "react";
import GainSelect from "../../../components/objects/GainSelect";
import { Card, Table, Empty, Spin } from "antd";
import CardTitleFilter from "../../../components/objects/CardTitle";
import GainButton from "../../../components/objects/GainButton";

import {
  getScenarioStructure,
  getScenarios,
  getUsers,
  getEmissionType,
} from "../../../services/api";

import { Search, Sort } from "../../../tools";

import Filter from "./filter";

export default function Structure() {
  const [Sheets, setSheets] = useState([]);
  const [data, setData] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [dataColumn, setDataColumn] = useState([]);
  const [FilterOption, setFilterOption] = useState({});
  const [FileName, setFileName] = useState("");

  const [NotFound, setNotFound] = useState(true);
  const [LoadingTable, setLoadingTable] = useState(false);
  const [Loading, setLoading] = useState(false);

  const [ActiveSheet, setActiveSheet] = useState({ key: 0, sheet: "" });

  useEffect(() => {
    Scenarios();
  }, []);

  useEffect(() => {
    Lists(FilterOption?.scenario, "1. FC");
    setFileName(FilterOption?.scenario);
  }, [FilterOption]);

  const sheetSelect = (key, sheet) => {
    setActiveSheet({ key });
    console.log(FileName, sheet);
    Lists(FileName, sheet);
  };

  const Lists = async (file, sheet) => {
    setLoading(true);
    setLoadingTable(true);
    var payload = {
      file,
      sheet,
    };
    const res = await getScenarioStructure(payload);
    if (res.status === 200) {
      setSheets(res.data.sheets);
      setDataTable(res.data.data.values);
      setData(res.data.data.values);

      const columns = res.data.data.headers;
      setDataColumn(
        columns.map((column) => ({
          title: column,
          dataIndex: column,
          key: column,
        }))
      );

      setLoading(false);
      setNotFound(false);
      setLoadingTable(false);
    }
  };

  const Scenarios = async () => {
    const res = await getScenarios();
    if (res.status === 200) {
      Lists(res.data[0].file_name, "1. FC");
      setFileName(res.data[0].file_name);
    }
  };
  return (
    <div>
      <Filter onFilter={(e) => setFilterOption(e)} />
      <Spin spinning={Loading} tip="Loading...">
        {NotFound ? (
          <Empty className="mt-24" />
        ) : (
          <div>
            <div className="sheet flex overflow-x-scroll sheet whitespace-nowrap">
              {Sheets.map((sheet, key) => (
                <div
                  className="px-3 py-1 pb-2 cursor-pointer rounded-lg border border-gray-300"
                  style={
                    ActiveSheet.key === key
                      ? { backgroundColor: "#4462f2", color: "#ffffff" }
                      : { backgroundColor: "#ffffff", color: "#000000" }
                  }
                  onClick={() => sheetSelect(key, sheet.name)}
                >
                  {sheet.name}
                </div>
              ))}
            </div>
            <Card
              title={
                <CardTitleFilter
                  filterOptions={dataColumn}
                  add={false}
                  onSearch={(keyword) => {
                    const dataSearch = Search(data, keyword);
                    setDataTable(dataSearch);
                  }}
                  onSort={(dataIndex) => {
                    const dataSort = Sort(data, dataIndex);
                    setDataTable(dataSort);
                  }}
                />
              }
              className="rounded-lg relative bottom-2 border border-gray-300 border-b-0"
            >
              <Table
                dataSource={dataTable}
                columns={dataColumn}
                pagination={true}
                scroll={{ x: "auto" }}
                className="font-light"
                loading={LoadingTable}
              />
            </Card>
          </div>
        )}
      </Spin>
    </div>
  );
}
